import * as React from 'react'

import { classList } from 'react-classlist-helper'

interface IProps {
  hierarchyChains: string[]
  /** The location's resource ID (e.g. LOC-078), shown before the chain. */
  resourceId?: string | null
  className?: string
}

export const HIERARCHY_SEPARATOR = ' / '
const RESOURCE_ID_SEPARATOR = ' · '

/** A location's secondary line: its resource ID, then the path down to it. */
export function formatLocationSubtitle(
  resourceId?: string | null,
  path?: string | null,
): string | null {
  return [resourceId, path].filter(Boolean).join(RESOURCE_ID_SEPARATOR) || null
}

export default class HierarchyChains extends React.PureComponent<IProps> {
  public static defaultProps = {
    className: '',
  }

  private static renderHierarchyChain(
    chain: string[],
    resourceId?: string | null,
  ): JSX.Element {
    const chainToDisplay = formatLocationSubtitle(
      resourceId,
      chain?.slice().reverse().join(HIERARCHY_SEPARATOR),
    )
    if (!chainToDisplay) {
      return null
    }

    return (
      <div
        key={chainToDisplay}
        title={chainToDisplay}
        className="text-ellipsis"
      >
        {chainToDisplay}
      </div>
    )
  }

  public render() {
    const { hierarchyChains, resourceId, className } = this.props

    return (
      <div
        className={classList({
          'col hierarchy-chains-container': true,
          [className]: true,
        })}
      >
        {HierarchyChains.renderHierarchyChain(hierarchyChains, resourceId)}
      </div>
    )
  }
}
